<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-faqs" @click="showAddFaq">+ ADD FAQ</span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search FAQs"
              v-model="searchStr"
            /> </label
        ></span>
      </div>

      <div class="faqs" role="tablist">
        <b-card no-body class="mb-1" v-for="(faq, i) in faqs" :key="i">
          <b-card-header
            header-tag="header"
            :class="{ active: activeCollapse == 'faq' + i }"
            role="tab"
          >
            <b-button
              class="btn-collapse"
              block
              variant="collapse"
              v-b-toggle="'faq' + i"
              >{{ faq.q }}
            </b-button>
            <span
              class="edit"
              @click="showEditFaq(i)"
              v-b-popover.top.hover="'Edit'"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span
              class="delete"
              @click="showDeleteFaq(i)"
              v-b-popover.top.hover="'Delete'"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                  fill="#EF5C4A"
                />
              </svg>
            </span>
            <span class="chevron" v-b-toggle="'faq' + i">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-card-header>
          <b-collapse :id="'faq' + i" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>{{ faq.a }}</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <modal :id="faqModal">
        <div class="add-faq" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(faqModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Add" : "Edit" }} FAQ</h3>
          <div class="h-18"></div>
          <b-form-group>
            <b-form-input
              type="text"
              required
              v-model="ques"
              placeholder="Enter your question here"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="textarea-scroll">
            <b-form-textarea
              id="textarea-default"
              rows="8"
              no-resize
              v-model="ans"
              placeholder="Enter your answer here"
              @focus="limitWords"
            ></b-form-textarea>
            <span class="counter">{{ ans.length }}/250</span>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(faqModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addFaq"
              :disabled="
                ques.trim().length > 0 && ans.trim().length > 0 ? false : true
              "
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              @click="editFaq"
              v-else
              :disabled="
                ques.trim().length > 0 && ans.trim().length > 0 ? false : true
              "
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-faq del-faq" v-else>
          <span class="close-icon" @click="$bvModal.hide(faqModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete FAQ</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>
                {{ faqs[activeIndex].q }}
              </strong>
              Faq?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteFaq">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteFaq">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/common/modal";
export default {
  data() {
    return {
      faqModal: "faq-modal",
      searchStr: "",
      add: true,
      del: false,
      input: "",
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      ques: "",
      ans: "",
      allFaqs: this.profile._dashboards.blogger.faqs
        ? JSON.parse(JSON.stringify(this.profile._dashboards.blogger.faqs))
        : []
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Modal
  },
  computed: {
    faqs() {
      if (this.searchStr.trim() == "") return this.allFaqs;

      return this.allFaqs.filter(faq => {
        return (
          faq.q.toLowerCase().includes(this.searchStr.toLowerCase().trim()) ||
          faq.a.toLowerCase().includes(this.searchStr.toLowerCase().trim())
        );
      });
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }
      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
  },
  methods: {
    limitWords() {
      document
        .getElementById("textarea-default")
        .setAttribute("maxlength", 250);
    },
    showAddFaq() {
      this.del = false;
      this.add = true;
      this.ques = "";
      this.ans = "";
      this.$bvModal.show(this.faqModal);
    },
    showEditFaq(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.ques = this.faqs[i].q;
      this.ans = this.faqs[i].a;
      this.$bvModal.show(this.faqModal);
    },
    showDeleteFaq(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.faqModal);
    },
    addFaq() {
      this.faqs.push({ q: this.ques, a: this.ans, _created_at: new Date() });
      this.$bvModal.hide(this.faqModal);
      this.ques = "";
      this.ans = "";
      this.saveChanges();
    },
    editFaq() {
      this.faqs[this.activeIndex].q = this.ques;
      this.faqs[this.activeIndex].a = this.ans;
      this.$bvModal.hide(this.faqModal);
      this.input = "";
      this.saveChanges();
    },
    deleteFaq() {
      this.faqs.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.faqModal);
      this.saveChanges();
    },
    hideDeleteFaq() {
      this.$bvModal.hide(this.faqModal);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) {
        let val = Array.isArray(truthy) ? truthy : def;
        return val;
      } else {
        return def;
      }
    },
    saveChanges() {
      let dataToUpdateTags = {
        blogger: {
          faqs: this.faqs
        }
      };

      if (dataToUpdateTags) {
        this.$store
          .dispatch("user/updateProfileDashboardBlogger", dataToUpdateTags)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/getProfile").then(() => {
                this.$store.dispatch("user/showNotification", {
                  title: "FAQs Updated Successfully",
                  description:
                    "Users will not see this info until you Publish.",
                  variant: "success"
                });
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-faqs {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-faq {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-faq {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.faqs {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.counter {
  margin-top: 5px;
  font-size: 12px;
  float: right;
}
</style>
